import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  selector: 'app-dialog-conferma',
  templateUrl: './dialog-conferma.component.html',
  styleUrls: ['./dialog-conferma.component.scss']
})
export class DialogConfermaComponent {
  messaggio = '';
  isHTML = false;
  showButtonNo = true;
  showTerzoButton = false;
  buttonTerText = 'Annulla';
  buttonNoText = 'No';
  buttonOkText = 'Si';
  buttonOkColor = 'primary';
  buttonOkClass = '';
  stileUscita = false;
  noDanger = false;
  conPadding = false;
  titolo = 'Conferma azione';
  isSmallDevice: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogConfermaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.messaggio = this.data.messaggio;
    this.isHTML = this.data.isHTML ? this.data.isHTML : this.isHTML;
    this.showButtonNo = this.data.showButtonNo != null ? this.data.showButtonNo : this.showButtonNo;
    this.buttonNoText = this.data.buttonNoText ? this.data.buttonNoText : this.buttonNoText;
    this.buttonOkText = this.data.buttonOkText ? this.data.buttonOkText : this.buttonOkText;
    this.buttonOkColor = this.data.buttonOkColor ? this.data.buttonOkColor : this.buttonOkColor;
    this.buttonOkClass = this.data.buttonOkClass ? this.data.buttonOkClass : this.buttonOkClass;
    this.titolo = this.data.titolo ? this.data.titolo : this.titolo;
    this.stileUscita = this.data.stileUscita || false;
    this.noDanger = this.data.noDanger || false;
    this.conPadding = this.data.conPadding || false;
    this.showTerzoButton = this.data.showTerzoButton || false;
    this.buttonTerText = this.data.buttonTerText || '';
  }

  chiudiDialog(response) {
    this.dialogRef.close(response);
  }
}
